requestAnimationFrame(() => {
  if (!customElements.get('delivery-countdown')) {
    class DeliveryCountdown extends HTMLElement {
      constructor() {
        super();

        themeBase.onDOMContentLoadedTrigger(() => {
          const politiqueAtelier = document.querySelector(
            '.politique-atelier-produit'
          );

          /*
           * La grande politique est ajoutée uniquement aux produits
           * possédant le tag "atelier".
           */
          const estUnAtelier = politiqueAtelier !== null;

          if (estUnAtelier) {
            politiqueAtelier.id = 'politique-annulation-atelier';

            this.innerHTML = `
              <div class="atelier-policy-link">
                <div class="atelier-policy-link__icon" aria-hidden="true">
                  <svg
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <circle cx="12" cy="12" r="9"></circle>
                    <path d="M12 7v5l3 2"></path>
                  </svg>
                </div>

                <div class="atelier-policy-link__content">
                  <p class="atelier-policy-link__title">
                    Politique d’annulation
                  </p>

                  <a href="#politique-annulation-atelier">
                    Consultez les modalités de remboursement et d’annulation
                    <span aria-hidden="true">↓</span>
                  </a>
                </div>
              </div>
            `;

            return;
          }

          this.innerHTML = `
            <div class="delivery-info">
              <p>
                <strong>
                  Ramassage en boutique – prêt en 24 h
                </strong>
              </p>

              <p>
                <strong>Où nous trouver :</strong><br>
                585, rue Principale<br>
                Lachute, QC<br>
                J8H 1Y8
              </p>

              <p>
                <strong>Heures d'ouverture :</strong><br>
                Mercredi à samedi : 11 h à 16 h
              </p>
            </div>
          `;
        });
      }
    }

    customElements.define(
      'delivery-countdown',
      DeliveryCountdown
    );
  }
});